import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

export default function withViewPort(ChildComponent) {

    class WithViewPortWrapper extends Component {
        static propTypes = {
            viewPort: PropTypes.object
        }

        constructor(props) {
            super(props)
        }

        render() {
            return (
                <ChildComponent {...this.props} />
            )
        }
    }

    return connect(mapStateToProps)(WithViewPortWrapper)
}

const mapStateToProps = (state) => {
    const { viewPort } = state

    return {
        viewPort
    }
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-view-port.js